import React from "react";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import { BnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import type { FinanceToggleModalType } from "../../../utils/modalConstants";
import * as Modal from "../../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import * as Styles from "./styles/FinanceToggleStyles";
import { setFinanceOption } from "../../../../../../common-deprecated/redux/actions/UtilActions";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import CashPrice from "../common/price/CashPrice";
import { trackCancelModal, trackCloseModal, trackFinanceToggle } from "../../../utils/tracking";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import ButtonPrimary from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";
import ButtonSecondary from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonSecondary";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import { getBnbPriceConfig } from "../../../utils/settings/bnbFinanceSettingUtils";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const FinanceToggleModal = (props: ModalViewType<FinanceToggleModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const { webtitleSectionName: modelName, internalCode: modelCode } = useBnbSelector((state) => state.car.model);
    const colourName = useBnbSelector((state) => state.car.colour.name);
    const engineName = useBnbSelector((state) => state.car.motorization.engine.name);
    const basketTotal = useBnbSelector((state) => state.basket.total);
    const step = useBnbSelector((state) => state.navigation.step);

    const priceConfig = getBnbPriceConfig(commonSettings, modelCode, step);
    const cultureName = commonSettings.culture.name;

    const financeToggleModalDescriptionLabel = useBnbOptionalLabel("financeToggleModalDescription");

    const switchFinanceOption = (): void => {
        trackFinanceToggle(step, "cash", "cc-modal");
        dispatch(setFinanceOption("cash"));
        close();
    };

    const closeLabel = useCommonLabel("close");

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="financeOptionTotalCash" />
                </Modal.Title>
                <Modal.Button
                    aria-label={closeLabel}
                    onClick={() => {
                        trackCloseModal(step);
                        close();
                    }}
                >
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>

            <Modal.Body>
                {financeToggleModalDescriptionLabel && (
                    <Styles.Description>{financeToggleModalDescriptionLabel}</Styles.Description>
                )}
                <Styles.ModelName>{modelName}</Styles.ModelName>
                <Styles.EngineName>{engineName}</Styles.EngineName>
                <Styles.Description>{colourName}</Styles.Description>
                <Styles.Price>
                    <CashPrice price={basketTotal} priceConfig={priceConfig} cultureName={cultureName} />
                </Styles.Price>
                <Styles.Actions>
                    <ButtonSecondary
                        onClick={() => {
                            trackCancelModal(step);
                            close();
                        }}
                    >
                        <BnbLabel label="financeToggleModalCancel" />
                    </ButtonSecondary>
                    <ButtonPrimary onClick={switchFinanceOption}>
                        <BnbLabel label="financeOptionSwitchCash" />
                    </ButtonPrimary>
                </Styles.Actions>
            </Modal.Body>
        </ModalBaseView>
    );
};

export default FinanceToggleModal;
